import H2Base from "../../../components/ui/titles/H2Base";
import Button from "../../../components/ui/buttons/Button";
import { REGISTER_DIRECT_STATE } from "../../../constants/register";

const FinalCta = () => {
    return (
        <section className="py-16 text-center md:py-20">
            <H2Base
                text="Prêt à faire travailler votre épargne ?"
                tailwindClass="mx-auto max-w-2xl text-2xl md:text-3xl"
            />
            <p className="mx-auto max-w-xl leading-relaxed text-gray-600">
                Ouvrez votre compte investisseur en quelques minutes et échangez avec un conseiller PretUp pour
                construire votre allocation.
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
                <Button
                    btnType="secondary"
                    hover={true}
                    text="Ouvrir un compte investisseur"
                    link={{ external: false, href: "/inscription/preteur", state: REGISTER_DIRECT_STATE }}
                />
                <Button
                    btnType="secondaryBorder"
                    hover={true}
                    text="Échanger avec un conseiller"
                    link={{ external: false, href: "/contact" }}
                />
            </div>
        </section>
    );
};

export default FinalCta;
